import React from "react";
import Route from "./Routes";
import { ToastProvider } from "react-toast-notifications";

const App = () => {
  return (
    <ToastProvider>
      <Route />
    </ToastProvider>
  );
};

export default App;
